import colors from 'tailwindcss/colors'
import { getColors } from 'theme-colors'

const defaultPrimaryColors = getColors('#55688e')

function hexToRGB(hex: string): string {
  const hexMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (hexMatch) {
    const [r, g, b] = hexMatch.slice(1).map((c) => Number.parseInt(c, 16))
    return `${r}, ${g}, ${b}`
  }

  const hexMatchShort = /^#?([a-f\d])([a-f\d])([a-f\d])$/i.exec(hex)
  if (hexMatchShort) {
    const [r, g, b] = hexMatchShort.slice(1).map((c) => Number.parseInt(c + c, 16))
    return `${r}, ${g}, ${b}`
  }

  throw new Error('Invalid hex format! Use #ABC or #AABBCC')
}

export function tailwindColorToCssVar(key: string, colorSet: Record<number, string>) {
  const cssVar: Record<string, string> = {}

  Object.entries(colorSet).forEach(([colorKey, colorValue]) => {
    cssVar[`--color-${key}-${colorKey}`] = hexToRGB(colorValue)
  })

  return cssVar
}

const defaultColors = {
  ...tailwindColorToCssVar('primary', defaultPrimaryColors),
  ...tailwindColorToCssVar('secondary', colors.neutral),
  ...tailwindColorToCssVar('accent', colors.pink),
  ...tailwindColorToCssVar('error', colors.red),
  ...tailwindColorToCssVar('success', colors.green),
  ...tailwindColorToCssVar('warning', colors.yellow),
  ...tailwindColorToCssVar('info', colors.blue),
  ...tailwindColorToCssVar('link', colors.blue),
  ...tailwindColorToCssVar('gray', colors.gray),
}

export { defaultColors }
